import React, { Component } from 'react';

import { auth } from '../firebase';
import {Navbar, Icon} from 'react-materialize'

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  error: null,
};

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const { passwordOne } = this.state;

    auth.doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  render() {
    const {
      passwordOne,
      passwordTwo,
      error,
    } = this.state;

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '';

    return (
      <form onSubmit={this.onSubmit}>
        <div className='row'>
          <div className='input-field col s12'>
            <input
              className='validate'
              type='password'
              name='passwordOne'
              id='passwordOne'
              value={passwordOne}
              onChange={event => this.setState(byPropKey('passwordOne', event.target.value))}
            />
            <label htmlFor="passwordOne">Nova Senha</label>
          </div>
        </div>
        <div className='row'>
          <div className='input-field col s12'>
            <input
              className='validate'
              type='password'
              name='passwordTwo'
              id='passwordTwo'
              value={passwordTwo}
              onChange={event => this.setState(byPropKey('passwordTwo', event.target.value))}
            />
            <label htmlFor="passwordTwo">Confirma Nova Senha</label>
          </div>
        </div>

        <center>
          <div className='row'>
            <button type='submit' name='btn_login' className='col s12 btn btn-large waves-effect indigo'>Trocar senha<Icon>keyboard_arrow_right</Icon></button>
            { error && <p>{error.message}</p> }
          </div>
        </center>
      </form>
    );
  }
}

export default PasswordChangeForm;



// WEBPACK FOOTER //
// ./src/components/PasswordChange.js